module.exports = __webpack_public_path__ + "static/media/所有课程图片.a5ae41eb.png";